import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import '../../style-animations.css';


import Connection from '../../Calls';
import Backend from '../../Backend';

import CopyClip from '../../Images/copy-clip.png';

import EyeShow from '../../Images/eye-show.png';
import EyeHide from '../../Images/eye-hide.png';

import LockOpened from '../../Images/lock-opened.png';
import LockClosed from '../../Images/lock-closed.png';

export default class APIRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status:'',
      show:false,
      showLoad:false,
      totpImg:EyeHide,
      apiSecret:this.props.apiSecret,
      apiTotp:this.props.apiTotp,
      status:this.props.status,
      displayEye:this.props.status == 'enabled',
      apiLock:LockClosed,
      ClipboardText1:'Copy to clipboard',
      ClipboardText2:'Copy to clipboard',
      idTooltip1:'',
      idTooltip2:''
    }
  }

  showTOTP(){
    if(this.state.show){
      this.setState({
        show:false,
        totpImg:EyeHide,
        apiSecret:this.props.apiSecret,
        apiTotp:this.props.apiTotp,
      })
    }else{
      this.getAPISecret()
    }
  }

  getAPISecret(){
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload

      Backend.GetAPISecret(localStorage.getItem('email'), localStorage.getItem('token'), this.props.id, this.props.apiKey, payload.r01, response => {
        if(response.status.code == 0){
          this.setState({
            apiSecret:response.payload.apiSecret,
            apiTotp:response.payload.apiTotp,
            show:true,
            totpImg:EyeShow
          })
        }
      });

    })
  }

  lockKey(){
    if(this.state.locked){
      this.setState({
        locked:false,
        apiLock:LockClosed
      })
    }else{
      this.setState({
        locked:true,
        apiLock:LockOpened
      })
    }
  }

  changeAPIStatus(){
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload

      Backend.ChangeAPIStatus(localStorage.getItem('email'), localStorage.getItem('token'), this.props.id, this.props.apiKey, payload.r01, response => {
        if(response.status.code == 0){
          this.setState({
            status:response.payload.status
          })
          if(this.state.status === 'enabled'){
            this.setState({
              displayEye:true,
            })
          }else{
            this.setState({
              displayEye:false,
              show:false,
              totpImg:EyeHide,
              apiSecret:this.props.apiSecret,
              apiTotp:this.props.apiTotp,
            })
          }
          store.addNotification({
            title: "Success!",
            message: response.payload.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });

    })
  }

  CopyToClipboard1(){
    const self=this
    self.setState({ClipboardText1:'Copied to clipboard', idTooltip1:'tooltip-right fade-in'});
    setTimeout(function(){ self.setState({ idTooltip1:' tooltip-right fade-out'}) }, 1000)
    setTimeout(function(){ self.setState({ClipboardText1:'Copy to clipboard',idTooltip1:''}) }, 2000)

  }

  CopyToClipboard2(){
    const self=this
    self.setState({ClipboardText2:'Copied to clipboard', idTooltip2:'tooltip-right fade-in'});
    setTimeout(function(){ self.setState({ idTooltip2:' tooltip-right fade-out'}) }, 1000)
    setTimeout(function(){ self.setState({ClipboardText2:'Copy to clipboard',idTooltip2:''}) }, 2000)

  }

  render(){
    return(
      <tr className='api-tr'>
        <td className="text-table-container-addres-information">
          {this.props.apiKey}
        </td>
        <td className={"text-table-container-addres-information " + this.state.status}>
          {this.state.status}
        </td>
        {
          !this.props.noLastUse &&
          <td className="text-table-container-addres-information">
            {this.props.last_use}
          </td>
        }
        <td className="text-table-apikeys">
          <span>{this.state.apiSecret}</span>
          {
            (this.state.show)&&
              <OverlayTrigger
                placement={'top'}
                overlay={<Tooltip className={this.state.idTooltip1}> {this.state.ClipboardText1}</Tooltip>}
              >

              <CopyToClipboard text={this.state.apiSecret}>
                <button className='copy-api-clipboard' onClick={()=>{ this.CopyToClipboard1()}}>
                  <Image src={CopyClip}/>
                </button>
              </CopyToClipboard>

          </OverlayTrigger>
          }
        </td>
        <td className="text-table-apikeys">
          {this.state.apiTotp}{
          (this.state.show)&&
          <OverlayTrigger
            placement={'top'}
            overlay={
              <Tooltip className={this.state.idTooltip2}>
               {this.state.ClipboardText2}
              </Tooltip>
            }>
            <CopyToClipboard text={this.state.apiTotp}>
              <button className='copy-api-clipboard' onClick={()=>{ this.CopyToClipboard2()}}>
                <Image src={CopyClip}/>
              </button>
            </CopyToClipboard>
          </OverlayTrigger>

        }
        </td>
        <td style={{display:'flex', alignItems:'center'}}>
          {
            (this.state.displayEye)
            &&
            <button className='api-table-button' onClick={()=>this.showTOTP()}>
              <Image src={this.state.totpImg}/>
            </button>
          }
          <button className='api-table-button' onClick={()=>this.changeAPIStatus()}>
            <Image src={(this.state.status === 'enabled')?LockOpened:LockClosed}/>
          </button>
        </td>
      </tr>
    )
  }
}
